export default {
    assignLocation: 'ตำแหน่งสแกนใบหน้า',
    selected: 'เลือก',
    locationName: 'ค้นหาสถานที่',
    confirm: 'ยืนยัน',
    update: 'สำเร็จ',
    locationSuccessfully: 'อัปเดตตำแหน่งสแกนใบหน้า',
    errorMessage: 'Error Message'
}
